import { combineReducers } from 'redux'
import { reducer as session } from 'redux-simple-auth'
import { reducers as stylistReducers } from 'stylist'
import { reducer as surveyMeta } from './surveyMeta'

export default combineReducers({
  notifications: stylistReducers.notifications,
  session,
  surveyMeta
})



// WEBPACK FOOTER //
// ./src/reducers/index.js